/**
 * Pack progress trust — variant sync + one-shot scroll reveal.
 * Stops = 1/3, 2/3, full pack_days. Animation uses CSS transitions only.
 */
(function () {
  function parseMap(root) {
    var el = root.querySelector('[data-pack-progress-variants]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function tmpl(str, map) {
    var out = str || '';
    Object.keys(map).forEach(function (key) {
      out = out.split('[' + key + ']').join(String(map[key]));
    });
    return out;
  }

  function milestoneDays(packDays, fixed) {
    var days = packDays > 0 ? packDays : 90;
    var m1 = Math.floor(days / 3) || 1;
    var m2 = Math.floor((days * 2) / 3) || m1 + 1;
    var m3 = days;
    if (m2 <= m1) m2 = m1 + 1;
    if (m2 >= m3 && m3 > 1) m2 = m3 - 1;
    // Optional fixed days for stops 1 and 2 (data-fixed-stops="1,30"); stop 3 stays the pack length.
    if (fixed && fixed.length) {
      var f1 = fixed[0] || 0;
      var f2 = fixed[1] || 0;
      if (f1 > 0 && f1 < m3) m1 = f1;
      if (f2 > m1 && f2 < m3) m2 = f2;
    }
    return [m1, m2, m3];
  }

  function fixedStops(root) {
    var raw = root.dataset.fixedStops;
    if (!raw) return null;
    return raw.split(',').map(function (v) {
      return parseInt(v, 10) || 0;
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function update(root, days, units) {
    var stopCount = parseInt(root.dataset.stopCount, 10) || 3;
    var daysSafe = days > 0 ? days : 90;
    var marks = milestoneDays(daysSafe, fixedStops(root));
    var stops = root.querySelectorAll('[data-pp-stop]');

    stops.forEach(function (stop, index) {
      var day = marks[index] || 0;
      stop.setAttribute('data-day', String(day));
      stop.classList.add('is-included');
      stop.classList.toggle('is-current', index === stops.length - 1);

      var dayEl = stop.querySelector('[data-pp-stop-day]');
      if (dayEl) dayEl.textContent = 'DAY ' + day;
    });

    var titleEl = root.querySelector('[data-pp-title]');
    if (titleEl) {
      titleEl.textContent = tmpl(root.dataset.titleTemplate || 'YOUR [days]-DAY PROGRESS', {
        days: daysSafe,
        n: stopCount,
        x: stopCount,
      });
    }

    var badgeEl = root.querySelector('[data-pp-badge]');
    if (badgeEl) {
      badgeEl.textContent = tmpl(root.dataset.badgeAll || 'All [n] included', {
        n: stopCount,
        x: stopCount,
        days: daysSafe,
      });
    }

    var statusEl = root.querySelector('[data-pp-status]');
    if (statusEl) {
      statusEl.textContent = tmpl(root.dataset.statusTemplate || 'Your pack covers all [n] stops', {
        n: stopCount,
        x: stopCount,
        days: daysSafe,
      });
      statusEl.classList.remove('is-partial');
    }

    root.dataset.currentDays = String(daysSafe);
    root.dataset.currentUnits = String(units || 0);
  }

  function play(root) {
    if (root.dataset.ppPlayed === '1') return;
    root.dataset.ppPlayed = '1';

    root.classList.add('is-ready');
    root.classList.add('is-pending');
    void root.offsetWidth;

    requestAnimationFrame(function () {
      root.classList.remove('is-pending');
      root.classList.add('is-inview');
    });
  }

  function showStatic(root) {
    root.dataset.ppPlayed = '1';
    root.classList.remove('is-pending');
    root.classList.add('is-ready');
    root.classList.add('is-inview');
  }

  function observeInView(root) {
    if (root.dataset.ppObserved === '1') return;
    root.dataset.ppObserved = '1';

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      showStatic(root);
      return;
    }

    root.classList.add('is-ready');
    root.classList.add('is-pending');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          play(root);
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -5% 0px' }
    );

    io.observe(root);
  }

  function bind(root) {
    if (root.dataset.ppBound === '1') return;
    root.dataset.ppBound = '1';

    var map = parseMap(root);
    var productInfo = root.closest('product-info');

    function applyFromVariant(variant) {
      if (!variant || !variant.id) return;
      var entry = map[String(variant.id)] || map[variant.id] || {};
      update(root, parseInt(entry.days, 10) || 0, parseInt(entry.units, 10) || 0);
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        if (productInfo && event.data.sectionId && String(event.data.sectionId) !== String(root.dataset.sectionId)) {
          return;
        }
        applyFromVariant(event.data.variant);
      });
    }

    var selectedScript = productInfo && productInfo.querySelector('variant-selects [data-selected-variant]');
    if (selectedScript) {
      try {
        applyFromVariant(JSON.parse(selectedScript.textContent));
      } catch (e) {}
    }

    observeInView(root);
  }

  function initAll() {
    document.querySelectorAll('[data-pack-progress]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-pack-progress]').forEach(function (root) {
      root.dataset.ppBound = '';
      root.dataset.ppObserved = '';
      root.dataset.ppPlayed = '';
      root.classList.remove('is-ready', 'is-pending', 'is-inview');
    });
    initAll();
  });
})();
